import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RemoveUsersFromStaffMutationVariables = Types.Exact<{
  input: Types.RemoveUsersFromStaffInput;
}>;


export type RemoveUsersFromStaffMutation = { removeUsersFromStaff: { success?: boolean | null } };


export const RemoveUsersFromStaffDocument = /*#__PURE__*/ gql`
    mutation removeUsersFromStaff($input: RemoveUsersFromStaffInput!) {
  removeUsersFromStaff(input: $input) {
    success
  }
}
    `;

export function useRemoveUsersFromStaffMutation() {
  return Urql.useMutation<RemoveUsersFromStaffMutation, RemoveUsersFromStaffMutationVariables>(RemoveUsersFromStaffDocument);
};